// extracted by mini-css-extract-plugin
export var statItem = "_lf-1";
export var statsRow = "_lf-0";